module.exports = __webpack_public_path__ + "img/MEDIA118.d76a5f34.jpg";